/** Refresh the authoritative agent overlay before surfacing a partial delete failure. */
export async function recoverAgentDeleteFailure(
  error: unknown,
  refresh: () => Promise<void>,
): Promise<never> {
  await refresh();
  throw error;
}
